import methodist from "./methodist";
import teacher from "./teacher";
import toAll from "./to-all";
import auth from "./auth";

export default {
  methodist,
  teacher,
  toAll,
  auth,
}